import React from 'react';
import HeroSection from '../components/features-new/HeroSection';
import TrustedSection from '../components/features-new/TrustedSection';
import FeatureCategory from '../components/features-new/FeatureCategory';
import HighlightFeature from '../components/features-new/HighlightFeature';
import HowItWorks from '../components/features-new/HowItWorks';
import PricingComparison from '../components/features-new/PricingComparison';
import Testimonials from '../components/features-new/Testimonials';
import FinalCTA from '../components/features-new/FinalCTA';
import '../components/features-new/FeaturesStyles.scss';

function FeaturesPage() {
  return (
    <div>
      <HeroSection />
      <TrustedSection />
      <FeatureCategory />
      <HighlightFeature />
      <HowItWorks />
      <PricingComparison />
      <Testimonials />
      <FinalCTA />
    </div>
  );
}

export default FeaturesPage;
